var _a;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import view from './knowledge.view.html';
import { ITimeoutService } from 'angular';
import './knowledge.scss';
import { debounce } from 'data/function';
import { BuilderFeatures } from '../../../../BuilderFeatures';
let Knowledge = class Knowledge {
    static $inject = ['$timeout'];
    constructor($timeout) {
        'ngInject';
        this.catalogs = [];
        this.agentCatalogs = [];
        this.showGroundingToolsMigrationAlert = false;
        this.filtredAgentCatalogs = [];
        this.searchTerm = '';
        this.$onChanges = (changes) => {
            if (changes.isLoading && !changes.isLoading.currentValue) {
                this.updateFiltredCatalogs();
            }
        };
        this.updateFiltredCatalogs = () => {
            this.$timeout(() => {
                if (!this.agentCatalogs) {
                    return;
                }
                if (this.searchTerm === '') {
                    this.filtredAgentCatalogs = this.agentCatalogs;
                }
                else {
                    this.filtredAgentCatalogs = this.agentCatalogs
                        .filter((catalog) => catalog.name?.toLowerCase().trim().includes(this.searchTerm.toLowerCase().trim()));
                }
            });
        };
        this.onCatalogSearch = async (event) => {
            this.searchTerm = event.detail.value;
            this.debouncedFilter();
        };
        this.$timeout = $timeout;
        this.debouncedFilter = debounce(this.updateFiltredCatalogs, 500);
    }
    //#endregion
    //#region Lifecycle Hooks
    async $onInit() {
        await this.checkFeatures();
        await this.updateGroundingToolsMigrationAlert();
        this.debouncedFilter();
    }
    //#endregion
    //#region Methods
    async checkFeatures() {
        this.isStudioGroundingToolsMigrationEnabled = await BuilderFeatures.isStudioGroundingToolsMigrationEnabled();
    }
    openCatalogManagerModal() {
        this.onOpenCatalogManagerModal?.();
    }
    openCatalogDocumentsModal(agentCatalog) {
        this.onOpenCatalogDocumentsModal?.({ $agentCatalog: agentCatalog });
    }
    openGroundingMigrationModal() {
        // Close sidebar before opening modal
        this.onCloseSidebar?.();
        const modal = document.getElementById('grounding-migration-modal');
        if (modal) {
            modal.setAttribute('open', 'true');
        }
    }
    async updateGroundingToolsMigrationAlert() {
        this.showGroundingToolsMigrationAlert = this.isStudioGroundingToolsMigrationEnabled;
    }
};
Knowledge.$inject = ['$timeout'];
Knowledge = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: view,
        bindings: {
            onOpenCatalogManagerModal: '&?',
            onOpenCatalogDocumentsModal: '&?',
            onCloseSidebar: '&?',
            isLoading: '<',
            catalogs: '<',
            agentCatalogs: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ITimeoutService !== "undefined" && ITimeoutService) === "function" ? _a : Object])
], Knowledge);
export { Knowledge };
